import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import CheckBox from "../../../PageLayout/CheckBox";
import {setWizardPopupDisabledScenes} from "../../wizardActions";
import {toggleArrayValue} from "../../../FeatureCreator/FeaturesFilters/filtersFunctions";


const WizardPopupSceneSelectionItem = (props) => {

  const {preset, wizardPopupDisabledScenes, setWizardPopupDisabledScenes} = props;

  const checked = !wizardPopupDisabledScenes.includes(preset.id);

  const checkSceneClick = () => {
    setWizardPopupDisabledScenes(toggleArrayValue(wizardPopupDisabledScenes, preset.id));
  }

  return (
    <li className="wizard-preset">
      <img src={preset.bv_screen} className="wizard-preset__img" alt=""/>
      <div className="wizard-preset__info">
        <CheckBox checked={checked}
                  onChecked={checkSceneClick}
                  text=""/>
        <span className="wizard-preset__info-text">id: {preset.lookId}</span>
        <span className="wizard-preset__info-text">lookId: {preset.id}</span>
        <span className="wizard-preset__info-text">layout: {preset.layout_type}</span>
        <span className="wizard-preset__info-text">scene: {preset.scene}</span>
      </div>
    </li>
  )
};

WizardPopupSceneSelectionItem.propTypes = {
  preset: PropTypes.object.isRequired
}

const mapStateToProps = (store) => {
  const {wizardPopupItem, wizardPopupDisabledScenes} = store.wizardState;
  return {
    wizardPopupItem,
    wizardPopupDisabledScenes,
  };
};

const mapDispatchToProps = {
  setWizardPopupDisabledScenes,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(WizardPopupSceneSelectionItem)
)
